import { render, staticRenderFns } from "./WhatsAppAccountsEdit.vue?vue&type=template&id=53621bb7&"
import script from "./WhatsAppAccountsEdit.vue?vue&type=script&lang=js&"
export * from "./WhatsAppAccountsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports